import Admin2 from "layouts/Admin2";
import Aggregates from "./Aggregates";
import SubscriptionSeatsCard from "./SubscriptionSeatsCard";

const InstitutionDashboard = () => {
	return (
		<Admin2>
			<div className="space-y-8 my-4" style={{ minWidth: "80%" }}>
				<SubscriptionSeatsCard />

				<Aggregates />

				{/* <MostReadBooks /> */}
			</div>
		</Admin2>
	);
};

export default InstitutionDashboard;
